import { secondarySearch } from "../../components/indexDB/indexDBStora";

export async function ValidatioProduct (newProduct) {
    const result = {
        message: "",
        status: false
    }
    if(newProduct.meta.barcode === '') {
        result.message = "enter the barcode of product please";
        return result;
    }
    if(newProduct.nameProudct === '') {
        result.message = "enter the name of product please";            
        return result;
    }
    if(newProduct.sku.length < 9) {
        result.message = "SKU invalid"             
        return result;
    }
    if(newProduct.tax.taxType === "") {
        result.message = "please select tax type"
        return result;    
    }
    if(newProduct.tax.taxValue > 100) {
        result.message = "this is tax invalid"             
        return result;    
    }
    if(!newProduct.sellPrice || isNaN(newProduct.sellPrice)) {
        result.message = "please enter valid sell price";
        return result;
    }
    if(newProduct.categoryId === "") {
        result.message = "please select the category"
        return result;
    }
    
    const repeatedProduct = await secondarySearch("products", "barcode", newProduct.meta.barcode);
    
    if(repeatedProduct.length > 0) {
        result.message = "the product is repeated";
        return result;
    }

    result.status =  true
    return result;
}